import { APP_CONSTANTS } from '@/config/constants';
import { databaseService } from '@/services/databaseService';
import {
  getSyncClientBuild,
  HISTORICAL_SNAPSHOTS_FEATURE,
  syncCanaryFeatureDecisionStore,
} from '@/services/sync/SyncCanaryFeatureService';
import {
  ChecklistHistoricalReadService,
  type ChecklistHistoricalReadRepository,
  type ChecklistSnapshotFeatureProvider,
  type ChecklistSnapshotFieldRecord,
  type ChecklistSnapshotRecord,
  type ChecklistValueRecord,
} from './ChecklistHistoricalReadService';

export const localChecklistHistoricalReadRepository: ChecklistHistoricalReadRepository = {
  listSnapshots(companyId, checklistId) {
    return databaseService.listItems<ChecklistSnapshotRecord>(
      APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLIST_SNAPSHOTS.NAME,
      { empresa_id: companyId, checklist_id: checklistId }
    );
  },
  listSnapshotFields(companyId, snapshotId) {
    return databaseService.listItems<ChecklistSnapshotFieldRecord>(
      APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLIST_SNAPSHOT_FIELDS.NAME,
      { empresa_id: companyId, snapshot_id: snapshotId }
    );
  },
  listValues(companyId, checklistId) {
    return databaseService.listItems<ChecklistValueRecord>(
      APP_CONSTANTS.DATABASE.TABLES.GUINCHO_VALORES_CHECKLIST.NAME,
      { empresa_id: companyId, checklist_id: checklistId }
    );
  },
};

export const recoverySnapshotFeatureProvider: ChecklistSnapshotFeatureProvider = {
  async isEnabled(companyId) {
    const clientBuild = getSyncClientBuild();
    if (clientBuild < 72 || !companyId.trim()) {
      return false;
    }

    return syncCanaryFeatureDecisionStore.get({
      companyId,
      featureKey: HISTORICAL_SNAPSHOTS_FEATURE,
      clientBuild,
    });
  },
};

export const checklistHistoricalReadService = new ChecklistHistoricalReadService(
  localChecklistHistoricalReadRepository,
  recoverySnapshotFeatureProvider
);
